import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import CoursesFormCst from "../CoursesFormCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useAddCourses } from "@hooks/hookscatalog/Courses/useAddCourses";
import { PagesID } from "@utils/utilsConfigurations";

const AddCourses: React.FC = () => {
  const { t } = useTranslation(["courses-page"]);

  const navigate = useNavigate();
  const { id } = useParams();

  const [confirmCompletedLOModal, setConfirmCompletedLOModal] =
    useState<any>(undefined);

  const { onSubmit, openToast, setOpenToast, columns, actionsForForms } =
    useAddCourses(PagesID["corporate.catalog.courses"], id);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-courses.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <CoursesFormCst
              row={{ specializations: "NONE" }}
              columns={columns}
              onSubmit={onSubmit}
              setConfirmCompletedLOModal={setConfirmCompletedLOModal}
              backButton={() => {
                navigate(`/corporate/${id}/detail/catalog/courses`);
              }}
              actionsForForms={actionsForForms}
              isCreate={true}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
      <ModalConfirmsCst
        open={!!confirmCompletedLOModal}
        title={t("modal-confirm-completed.hero-title")}
        description={t("modal-confirm-completed.hero-description")}
        onCallBackClosed={() => {
          setConfirmCompletedLOModal(undefined);
        }}
        onActionConfirmed={() =>
          onSubmit(
            confirmCompletedLOModal.inputForm,
            confirmCompletedLOModal.fileUploaded,
          )
        }
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddCourses;
